module.exports = __webpack_public_path__ + "img/IMG_9512_L_Black_MockedUp.4c773cee.jpg";